import {
  getGetFrontRichiesteIdAllegatiQueryKey,
  getGetFrontRichiesteIdProcuratoreQueryKey,
  useDeleteFrontRichiesteIdProcuratore,
} from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { getGetFrontRichiesteIdRiepilogoDownloadQueryKey } from '@framework/api-client/api/inquiries-compile/riepilogo-richiesta/riepilogo-richiesta.ts';
import { useMemo } from 'react';
import { queryClient } from '../../../../core/network/queryClient.ts';

/**
 * Hook che ritorna la funzione per rimuovere il gestore di una richiesta.
 */
export function useRemoveSubmissionManager() {
  const removeAttorney = useDeleteFrontRichiesteIdProcuratore();

  const remove = useMemo(
    () => ({
      mutateAsync: async (submissionId: string) => {
        await removeAttorney.mutateAsync({
          id: submissionId,
        });
        await queryClient.invalidateQueries(
          getGetFrontRichiesteIdProcuratoreQueryKey(submissionId),
        );
        await queryClient.invalidateQueries(
          getGetFrontRichiesteIdRiepilogoDownloadQueryKey(submissionId),
        );
        await queryClient.invalidateQueries(
          getGetFrontRichiesteIdAllegatiQueryKey(submissionId),
        );
      },
    }),
    [removeAttorney],
  );

  return { remove };
}
